import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import TermsIcon from "@mui/icons-material/School";
import EditNoteIcon from "@mui/icons-material/EditNote";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_ALL_TEAMS_QUERY, DELETE_TEAM_MUTATION } from "../../graphQL/team_qry";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function TeamList() {
  
  //const [loadData, setLoadData] = useState(true);
  const [loadContent, setLoadContent] = useState(false);
  const [previewAlertMsg, setPreviewAlertMsg] = useState([]);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [clientTeamList, setClientTeamList] = useState([]);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  if (clientId == 0)
    loadData = false;

  let clientName = "";
  if (localStorage.getItem("clientName")) 
    clientName = localStorage.getItem("clientName");

  const classes = useStyles();

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [termsAccess, setTermsAccess] = useState(false);
    

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Teams",
              modulepageName: "List"     
            },
          });
    
    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      if(additionalActions.find(a => a == "Terms"))
        setTermsAccess(true)
                
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }  

  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);  

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [fetchAllTeams] = useManualQuery(GET_ALL_TEAMS_QUERY);

  const [deleteTeamMutation] = useMutation(DELETE_TEAM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const getTeamsList = async () => {
    const {
      loading: teamsListLoading,
      error: teamsListError,
      data: teamsListData,
    } = await fetchAllTeams({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!teamsListLoading && teamsListData && teamsListData.allTeams) {
      setClientTeamList(teamsListData.allTeams);
      
      loadData = true;
    }
    else 
      loadData = false;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTeamsList())();
  }, []);

  function checkDeleteStatus(row) {
    if (row.deletable === false)
      setAlertDeleteMsg({
        title: "Delete Team",
        msg: "You cannot delete this team, because it has member(s) in term.",
      });
    else
      setAlertDeleteMsg({
        title: "Delete Team",
        type: "deleteConfirmation",
        msg: "Are you sure you want to delete the team “" + row.name + "”?",
        teamId: row.id,
      });
  }

  const deleteTeam = async teamId => {
    const {
      loading: loadingTeamDelete,
      error: errorTeamDelete,
      data: dataTeamDelete,
    } = await deleteTeamMutation({
      variables: {
        teamId: parseInt(teamId),
      },
    });
    if (!loadingTeamDelete && dataTeamDelete && dataTeamDelete.deleteTeam) {
      getTeamsList();
    }
    if (errorTeamDelete) {
      if (errorTeamDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorTeamDelete.graphQLErrors[0].message);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 170,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "createDate",
      headerName: "Create Date",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "updateDate",
      headerName: "Update Date",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editPath = `${project_url}/teams/` + rows.row.uuid;

        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        var termsCursor = rows.row.termsAccess ? "pointer" : "auto";

       
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="List of Terms">
              <TermsIcon
                color={rows.row.termsAccess ? "action" : "disabled"}
                style={{
                  paddingRight: 15,
                  paddingTop: 6,
                  cursor: termsCursor,
                  fontSize: 24,
                }}
                onClick={() => rows.row.termsAccess ? navigate(`${project_url}/teams/` + rows.row.uuid + "/terms") : ""}
              />
            </StyledTooltip>
            
            <StyledTooltip title="Edit this team">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() => rows.row.editAccess ? navigate(editPath):""}
              />
            </StyledTooltip>
            <StyledTooltip title="Delete this team">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() => rows.row.deleteAccess ?checkDeleteStatus(rows.row):""}
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  var rows = clientTeamList.map(currTeam => ({
        id : currTeam.teamId,
        uuid : currTeam.teamUuid,
        name : currTeam.name,
        desc : currTeam.desc,
        deletable : currTeam.deletable,
        createDate : dayFormat(currTeam.createDate),
        updateDate : dayFormat(currTeam.updateDate),
        editAccess : editAccess,
        deleteAccess : deleteAccess,
        termsAccess : termsAccess
                
  }));

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Teams
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() => addAccess ? navigate(`${project_url}/teams/add`) : ""}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  if (loadContent)  
   if (loadData)   
   if (access)
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
          />

          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteTeam(alertDeleteMsg.teamId);
              }}
            />
          )}
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Client"
                contentMsg='There is no client in this Tenant. Please create a client.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default TeamList;
